export default __webpack_public_path__ + "static/media/1313.f64b67ef.png";